import whiteArrow from "../../Images/white-arrow.png"

export const BlogData = [
    {
        id : 1,
        name : "5 makeup trends that are here to stay",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 2,
        name : "Preparing for your hair consultation",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 3,
        name : "nurturing the prenatal body with ayurveda",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 4,
        name : "What your skin care regimen is missing: aveda serums",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 5,
        name : "Top 3 travel destinations to visit in 2022",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 6,
        name : "Five reasons why people love airbrush makeup ",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 7,
        name : "Treat yourself to the whole body experience",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 8,
        name : "Top 4 easy hair care tips for this monsoon",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 9,
        name : "The benefits of skin peels for healthy glowing skin",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 10,
        name : "Short haircut & hairstyles for women",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 11,
        name : "5 beauty mistakes you shouldn’t be getting in a flap over ",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
    {
        id : 12,
        name : "The importance of going to the spa",
        date : "22 Dec, 2022",
        para : "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
        arrow :whiteArrow
    },
   
]